import { useSelector } from "react-redux";
import { toast } from "sonner";
import { getTemplateFunction } from "../../../functions";

const LivePreview = ({ invoice }) => {
  const {
    billType,
    vehicle,
    transport,
    station,
    customerDetails,
    invoiceNumber,
    stateOfSupply,
    eWayBillNo,
    billToId,
    items,
    // isTaxIncluded,
  } = invoice;
  const isMobileView = useSelector((state) => state.mobileView.isMobileView);
  const companyDetails = useSelector(
    (state) => state.companyDetails.companyDetails
  );
  if (isMobileView) {
    toast.error("Preview is not available on mobile view");
    return null;
  }
  return (
    <div className="lg:flex flex-col hidden">
      <div
        className="mt-2"
        dangerouslySetInnerHTML={{
          __html: getTemplateFunction(companyDetails.defaultTemplate)(
            {
              billType,
              vehicle,
              companyDetails,
              transport,
              station,
              customerDetails,
              invoiceNumber,
              stateOfSupply,
              eWayBillNo,
              billToId,
              items,
              isPreview: true,
            },
            ""
          ),
        }}
      />
    </div>
  );
};

export default LivePreview;
